export const unSelectedAllMultiOption = multiSelectOptions => {
  return multiSelectOptions.map(op => {
    op.selected = false;
    return op;
  });
};

export const selectedMultiOption = multiSelectOptions => filter => {
  multiSelectOptions.map(op => {
    if (op.value === filter.value) {
      op.selected = true;
    }
    return op;
  });
};

export const getSelectedMultiOption = multiSelectOptions => {
  return multiSelectOptions.filter(s => s.selected);
};

export const isEmptySelectedFilters = () => {
  return getSelectedMultiOption().length === 0;
};

export const updateSelectedMultiOptions = multiSelectOptions => filters => {
  return multiSelectOptions.map(op => {
    const found = filters.find(f => f.value === op.value);
    if (found) {
      op.selected = true;
    } else {
      op.selected = false;
    }
    return op;
  });
};

export const isSelectedLeads = checkedStatus => {
  return ['single', 'all'].includes(checkedStatus);
};

export const unSelectedMultiOption = multiSelectOptions => value => {
  return multiSelectOptions.map(op => {
    if (op.value === value) {
      op.selected = false;
    }
    return op;
  });
};
